export const coverageFlowStyles = Object.freeze(
  /** @type {const} */ ({
    CERT_ONLY: 'certOnly',
    MANAGER_ONLY: 'managerOnly',
    CERT_AND_MANAGER: 'certAndManager',
  })
);
